export default __webpack_public_path__ + "static/media/documento-anterior-nuevo.96567179.png";